import { Component, Input, forwardRef, Optional, Host, SkipSelf, OnInit, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, ControlContainer, AbstractControl, FormsModule } from '@angular/forms';
import { NgIf, NgClass, NgFor } from '@angular/common';
import { NgxIntlTelInputModule } from 'untold-ngx-intl-tel-input';


@Component({
    selector: 'app-dropdown-input',
    templateUrl: './dropdown-input.component.html',
    styleUrls: ['./dropdown-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DropdownInputComponent),
            multi: true,
        },
    ],
    imports: [NgIf, FormsModule, NgxIntlTelInputModule, NgClass, NgFor],
    standalone: true
})
export class DropdownInputComponent implements ControlValueAccessor, OnInit, OnChanges {
  @Input() label;
  @Input() requiredMark = false;
  @Input() options;
  @Input() optionProperty;
  @Input() disableDefault = true;
  @Input() disableOtherOptions = false;
  @Input() acceptOutsideList = false;
  @Input() initValue = false;
  @Input() tabId = 0;
  @Input() placeholder;
  @Input() invalidMsg = 'Invalid field';
  @Input() submitAttempted = false;
  @Input() formControlName: string;
  @Input() inputClasses = '';
  @Input() optgroupProperty = '';
  @Input() optgroupPropertyValue = '';
  @Output() change = new EventEmitter;

  public disabled = false;
  public model;
  public currentControl: AbstractControl;
  public _value = '';
  public propagateChange: any = () => {};

  public processedOptions = [];

  hasCategories = false;

  loading = false;

  constructor(
    @Optional()
    @Host()
    @SkipSelf()
    private controlContainer: ControlContainer
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.options) {
      if (this.optionProperty) {
        this.loading = true;
      }
      this.processedOptions = this.getProcessedOptions();
      
      if (this.optionProperty) {
        setTimeout(() => {
          this.loading = false;
        });
      }
    };
  }

  getProcessedOptions() {
    if (this.optionProperty && this.optgroupProperty)  {
      const optionsGroups = [];
      // use the options thath have the optgroup property set to true as parents, add the ones below them as children
      this.options.forEach((v, i) => {
        if (v[this.optgroupProperty]) {
          optionsGroups.push({
            label: v[this.optionProperty],
            children: [],
          });
        } else {
          if (optionsGroups.filter(v => !v.grouplessOption).length === 0) {
            optionsGroups.push({
              label: v[this.optionProperty],
              grouplessOption: true,
            });
          } else {
            optionsGroups.filter(
              v => !v.grouplessOption)
            [optionsGroups.filter(v => !v.grouplessOption).length - 1]?.children.push({
              label: v[this.optionProperty], value: `${v[this.optionProperty]}${v[this.optgroupPropertyValue]}`
            });
          }
        }
      });
      if (optionsGroups.length) {
        this.hasCategories = true;
        return optionsGroups;
      }
    }

    this.hasCategories = false;
    if (this.optionProperty) {
      return this.options.map((v, i) => {
        return v[this.optionProperty];
      });
    } else {
      return this.options;
    }
  }

  ngOnInit() {
    if (this.controlContainer) {
      this.currentControl = this.controlContainer.control.get(this.formControlName);
      this.model = this.currentControl.value;
    }

    if (this.initValue) {
      this.model = this.initValue;
    }
  }

  writeValue(value: any) {
    if (value) {
      this._value = value;
      this.model = value;
    } else {
      this._value = null;
      this.model = null;
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: () => void): void {}

  onChange(event) {
    this.propagateChange(event.target.value);
  }

  setValue(value) {
    this.model = value;
    this.propagateChange(value);
    this.change.emit(value);
  }

  hasValidationError() {
    if (this.currentControl) {
      return !this.disabled && !this.currentControl.valid && this.submitAttempted;
    } else {
      return this.invalidMsg;
    }
  }

  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
  }
}
